<template>
  <div
    id="app"
    :class="{ 'app--login': isLoginRoute }"
    :style="{ color: COLORS.textPrimary, '--success': COLORS.success }"
  >
    <transition mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import COLORS from "@/constants/colors.js";
import { startAppVersionWatcher } from "@/utils/appVersion";

export default {
  data() {
    return {
      stopVersionWatcher: null,
    };
  },
  computed: {
    COLORS: () => COLORS,
    isLoginRoute() {
      return !!(this.$route && (this.$route.name === "Login" || this.$route.name === "Contato"));
    },
  },
  mounted() {
    this.stopVersionWatcher = startAppVersionWatcher();
  },
  beforeDestroy() {
    if (typeof this.stopVersionWatcher === "function") {
      this.stopVersionWatcher();
    }
  },
};
</script>

<style lang="scss">
html,
body {
  background-color: #fafafa;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-left: 20px;
  margin-top: 20px;
  background-color: #fafafa;
}

#app.app--login {
  margin: 0;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;

    &.router-link-exact-active {
      color: var(--success);
    }
  }
}

@media (max-width: 1260px) {
  #app {
    margin-left: 0;
  }
}
</style>
